import { Box, Card, CardContent, Typography } from '@mui/material'

import { computeConversionRates, type UserStats } from './analytics-utils'

type ConversionRateCardsProps = {
  overallStats: UserStats
  regularStats: UserStats
  contentOnlyStats: UserStats
}

const formatPct = (value: number): string => `${(value * 100).toFixed(1)}%`

type RateCardProps = {
  title: string
  stats: UserStats
}

function RateCard({ title, stats }: RateCardProps) {
  const rates = computeConversionRates(stats)

  return (
    <Card variant="outlined" sx={{ flex: '1 1 0', minWidth: 220 }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5 }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box>
            <Typography variant="body2" color="text.secondary">Signup → Verified</Typography>
            <Typography variant="h5" fontWeight="bold" color="primary.main">
              {formatPct(rates.signupToVerified)}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">Verified → Purchased</Typography>
            <Typography variant="h5" fontWeight="bold" color="success.main">
              {formatPct(rates.verifiedToPurchased)}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">Signup → Purchased</Typography>
            <Typography variant="h5" fontWeight="bold" color="warning.main">
              {formatPct(rates.signupToPurchased)}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export function ConversionRateCards({ overallStats, regularStats, contentOnlyStats }: ConversionRateCardsProps) {
  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
        Conversion Rates
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <RateCard title="Overall" stats={overallStats} />
        <RateCard title="Regular" stats={regularStats} />
        <RateCard title="Content-Only" stats={contentOnlyStats} />
      </Box>
    </Box>
  )
}
